import fuelIcon from "../assets/icons/fuel.svg";
import GuidAccordionCell from "../components/guidAccordionCell/GuidAccordionCell";

function generateUID() {
  return "xxxx-xxxx-xxxx-xxxx".replace(/[x]/g, function () {
    return Math.floor(Math.random() * 16).toString(16);
  });
}

export const chatBalanceHistoryMapper = ({ balanceHistory = [], t }) => {
  if (!Array.isArray(balanceHistory) || balanceHistory.length === 0) {
    return { headers: [], rows: [] };
  }

  const headers = Object.keys(balanceHistory[0]).map((key) => ({
    key,
    header: t(`main.chat.chatBalanceHistory.table.${key}`),
  }));

  const sortedData = [...balanceHistory].sort((a, b) => {
    const dateA = new Date(a.created).getTime();
    const dateB = new Date(b.created).getTime();
    return dateB - dateA;
  });

  const rows = sortedData.map((item) => {
    const row = {};
    Object.keys(item).forEach((key) => {
      if (key === "created") {
        const date = new Date(item[key]);

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const min = String(date.getMinutes()).padStart(2, "0");

        row[key] = `${yyyy}-${mm}-${dd} ${hh}:${min}`;
      } else if (key === "uuid") {
        row[key] = item[key] ? (
          <GuidAccordionCell item={item} t={t} source="balance" />
        ) : (
          "-"
        );
      } else if (key === "fuelDiff") {
        row[key] = (
          <div className="fuel_cell_main">
            <img src={fuelIcon} alt="Fuel" className="fuel_cell_img" />
            {item.fuelDiff > 0 ? `+${item.fuelDiff}` : item.fuelDiff}
          </div>
        );
      } else if (key === "fuelAfter") {
        row[key] = (
          <div className="fuel_cell_main">
            <img src={fuelIcon} alt="Fuel" className="fuel_cell_img" />
            {item.fuelAfter}
          </div>
        );
      } else if (key === "type") {
        switch (item[key]) {
          case "DEPOSIT":
            row[key] = t("main.chat.chatBalanceHistory.table.status.deposit");
            break;
          case "PAIDFR":
            row[key] = t("main.chat.chatBalanceHistory.table.status.paidFR");
            break;
          case "SETBALANCE":
            row[key] = t(
              "main.chat.chatBalanceHistory.table.status.setBalance",
            );
            break;
          default:
            row[key] = String(item[key]);
        }
      } else {
        row[key] = item[key] ? String(item[key]) : "-";
      }
    });
    row.id = item.id ?? generateUID();
    return row;
  });

  return { headers, rows };
};
